import { render, staticRenderFns } from "./AlcadaTabela.vue?vue&type=template&id=5022f620&lang=html&"
import script from "./AlcadaTabela.vue?vue&type=script&lang=js&"
export * from "./AlcadaTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/alcada/AlcadaTabela.vue
// module id = 1032
// module chunks = 28